interface TimeSeriesPoint {
    day: string;
    value?: number;
    successes?: number;
    failures?: number;
}

interface TimeSeriesChartProps {
    data: TimeSeriesPoint[];
    mode?: 'single' | 'auth';
}

export const TimeSeriesChart = ({ data, mode = 'single' }: TimeSeriesChartProps) => {
    const values = data.map((point) => {
        if (mode === 'auth') {
            return Number((point.successes || 0) + (point.failures || 0));
        }
        return Number(point.value || 0);
    });
    const max = Math.max(...values, 1);

    return (
        <div className="h-56 border border-slate-200/60 dark:border-slate-700/60 rounded-2xl p-4 bg-white dark:bg-slate-900">
            <div className="h-full flex items-end gap-2">
                {data.map((point, index) => {
                    const current = values[index] || 0;
                    const height = Math.max(6, Math.round((current / max) * 100));
                    const success = Number(point.successes || 0);
                    const failures = Number(point.failures || 0);
                    return (
                        <div key={`${point.day}-${index}`} className="flex-1 flex flex-col items-center justify-end gap-1">
                            {mode === 'auth' ? (
                                <>
                                    <div
                                        title={`success: ${success}`}
                                        className="w-full rounded-t-md bg-emerald-500/85"
                                        style={{ height: `${Math.max(3, Math.round((success / max) * 100))}%` }}
                                    />
                                    <div
                                        title={`failures: ${failures}`}
                                        className="w-full rounded-b-md bg-rose-500/80"
                                        style={{ height: `${Math.max(3, Math.round((failures / max) * 100))}%` }}
                                    />
                                </>
                            ) : (
                                <div
                                    className="w-full rounded-md bg-sky-500/85"
                                    style={{ height: `${height}%` }}
                                    title={`${current}`}
                                />
                            )}
                            <span className="text-[10px] text-slate-400 font-mono">{point.day.slice(5)}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
